import React, { useState } from 'react'
import { isFunction } from 'lodash'
import PropTypes from 'prop-types'
import { ALLOWED_ATTACHMENT_TYPES } from 'lib/constants'
import ExtendedDropzone from 'components/Upload/ExtendedDropzone/ExtendedDropzone'
import FileUploadLogic from 'components/Upload/FileUploadLogic'

export const AttachmentsContext = React.createContext()

const AttachmentsLogic = ({
    children,
    vehicleId,
    initAttachments,
    onFileSelected,
}) => {
    const [attachments, setAttachments] = useState(initAttachments || [])
    const [attachmentsDirty, setAttachmentsDirty] = useState(false)

    const handleAttachmentFileUploadSuccess = (result) => {
        const attachment = result.data.uploadVehicleAttachment
        setAttachments([...attachments, attachment])
        setAttachmentsDirty(true)
    }

    const handleRemoveAttachment = (attachment) => {
        setAttachments(attachments.filter(a => a.id !== attachment.id))
        setAttachmentsDirty(true)
    }

    const getContextState = () => {
        return {
            vehicleId,
            attachments,
            initAttachments,
            attachmentsDirty,
            handleRemoveAttachment,
        }
    }

    return (
        <FileUploadLogic>
            {(fileUploadLogic) => {
                const handleFileUploadDefault = (file) => {
                    return fileUploadLogic.uploadVehicleAttachment(vehicleId, file)
                        .then((result) => handleAttachmentFileUploadSuccess(result))
                }

                const handleFileUpload = onFileSelected || handleFileUploadDefault

                return (
                    <ExtendedDropzone
                        allowedTypes={ALLOWED_ATTACHMENT_TYPES}
                        maxSize={15000000}
                        multiple
                        onFileSelected={handleFileUpload}
                        allowMultiple={true}
                        noClick
                    >
                        <AttachmentsContext.Provider value={getContextState()}>
                            {isFunction(children) ? children(getContextState()) : children}
                        </AttachmentsContext.Provider>
                    </ExtendedDropzone>
                )
            }}
        </FileUploadLogic>
    )
}

AttachmentsLogic.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.node,
        PropTypes.func,
    ]).isRequired,
    vehicleId: PropTypes.string.isRequired,
    initAttachments: PropTypes.array,
    onFileSelected: PropTypes.func,
}

export default AttachmentsLogic
